import image1 from '../assets/contactConfigImage1.jpg';


export const contactConfig = {
      heading: "Get In Touch",
      subheading: "We'd love to hear from you",
      phone: "+1 (601) 981 8356",
      email: "bobbyslaughter@slaughtercomedy.com",
      buttonText: "Submit",
      contactImage: image1,
      fields: {
        name: "Name",
        email: "Email Address",
        subject: "Subject",
        message: "Message"
      }
    };